<template>
  <header class="header-nav">
    <div class="nav-container">
      <router-link to="/" class="logo-link">
        <h1 class="logo-text">なろう推薦</h1>
      </router-link>

      <nav class="main-nav">
        <router-link to="/home" class="nav-item">
          <i class="fas fa-home"></i>
          <span class="nav-text">ホーム</span>
        </router-link>
        <router-link to="/search" class="nav-item">
          <i class="fas fa-search"></i>
          <span class="nav-text">検索</span>
        </router-link>
        <router-link to="/account" class="nav-item">
          <i class="fas fa-user"></i>
          <span class="nav-text">アカウント</span>
        </router-link>
      </nav>

      <div class="auth-section">
        <div v-if="isLoggedIn" class="user-info">
          <span class="user-name">{{ userDisplayName }}</span>
          <button @click="handleLogout" class="auth-button logout">ログアウト</button>
        </div>
        <div v-else>
          <router-link to="/login" class="auth-button login">ログイン</router-link>
        </div>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();

// Vuexストアからログイン状態とユーザー情報を取得
const isLoggedIn = computed(() => store.getters['auth/isAuthenticated']);
const user = computed(() => store.getters['auth/currentUser']);

const userDisplayName = computed(() => {
  if (user.value) {
    return user.value.displayName || user.value.email;
  }
  return '';
});

// ログアウト処理
const handleLogout = async () => {
  await store.dispatch('auth/logout');
  // ログアウト後はLandingページにリダイレクト
  router.push('/');
};
</script>

<style scoped>
/* FontAwesomeのアイコンを利用するため、別途読み込みが必要です */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');

.header-nav {
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 0 20px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  height: 60px;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  height: 100%;
}

.logo-link {
  text-decoration: none;
}

.logo-text {
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
  margin: 0;
}

.main-nav {
  display: flex;
  gap: 20px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 15px;
  text-decoration: none;
  color: #555;
  font-weight: 500;
  border-radius: 8px;
  transition: background-color 0.2s, color 0.2s;
}

.nav-item:hover {
  background-color: #f0f2f5;
}

.nav-item.router-link-exact-active {
  color: #4A90E2;
  background-color: #e7f3ff;
}

.nav-item i {
  font-size: 18px;
}

.auth-section {
  display: flex;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.user-name {
  font-weight: 500;
  color: #333;
}

.auth-button {
  padding: 8px 16px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s;
  white-space: nowrap; /* ボタン内のテキストが折り返さないようにする */
}

.auth-button.login {
  background-color: #4A90E2;
  color: white;
  text-decoration: none;
}
.auth-button.login:hover {
  background-color: #357ABD;
}

.auth-button.logout {
  background-color: #f0f2f5;
  color: #555;
}
.auth-button.logout:hover {
  background-color: #e0e4e8;
}

/* ▼▼▼【ここからが修正箇所】▼▼▼ */

/* スマートフォン向けのレスポンシブ対応 */
@media (max-width: 768px) {
  .nav-container {
    padding: 0 10px;
  }

  .logo-text {
    font-size: 20px; /* ロゴを少し小さく */
  }

  /* 中央のナビゲーションメニュー */
  .main-nav {
    /* 画面中央に配置するためのテクニック */
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    gap: 0;
  }
  
  .nav-item {
    padding: 8px 12px; /* アイコンのみになるのでパディングを調整 */
  }

  /* ナビゲーションの文字を非表示に */
  .nav-text {
    display: none;
  }

  /* アイコンを少し大きくしてタップしやすく */
  .nav-item i {
    font-size: 22px; 
  }

  /* ユーザー名を非表示に */
  .user-name {
    display: none;
  }

  /* 認証ボタンのサイズ調整 */
  .auth-button {
    padding: 6px 12px;
    font-size: 14px;
  }
}
</style>